import { FC } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { InputAdornment, TextField } from '@mui/material'
import { useNumeric } from './useNumeric'

export const FilterCriteriaValuePercentage: FC<FilterCriteriaValueFieldProps> = ({
  fieldProps: { value, onChange, onBlur, ...fieldProps },
}) => {
  const { internalValue, handleChange, handleBlur } = useNumeric({
    value,
    onChange,
    onBlur,
  })

  return (
    <TextField
      variant="outlined"
      fullWidth
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        },
      }}
      {...fieldProps}
    />
  )
}
